import React, { useEffect, useRef, useState, useContext } from 'react'
import MiniWaves from '@/components/animations/MiniWaves'
import { useChatStore } from './chatStore'
import { RemoteConfigContext } from '@/context/RemoteConfigContext'

const AskAnythingButton = () => {
  const { setIsModalOpen } = useChatStore()
  const handleClick = () => {
    // save in local the current path where the user was before clicking on the button
    localStorage.setItem('previousPath', window.location.pathname)

    setIsModalOpen(true)
  }

  return (
    <div className="flex items-center justify-center cursor-pointer group" onClick={handleClick}>
      <div
        className="relative flex items-center justify-between bg-gradient-to-br from-gray-900 to-black/80 px-4 py-3 rounded-full shadow-2xl hover:shadow-xl transition-all 
        border border-white/10 
        ring-2 ring-black/20 
        hover:ring-black/30 
        hover:scale-105 
        active:scale-95 
        transform 
        duration-200 
        ease-in-out
        animate-breathing
        w-[220px]"
      >
        <div className="flex items-center h-[42px]">
          <div className="mr-2">
            <MiniWaves size="h-8 w-8" />
          </div>
          <span className="font-bold text-white">Ask Anything</span>
        </div>
      </div>
    </div>
  )
}

// TEMPORARILY DISABLED: Enter Flow button - can be re-enabled by uncommenting the component and its usage below
/*
const EnterFlowButton = () => {
  const { isDarkMode } = useTheme()
  const [isFlowLogOpen, setIsFlowLogOpen] = useState(false)
  const [unreadCount, setUnreadCount] = useState(5)
  const [subtitle, setSubtitle] = useState('Analyzing Last Meeting...')
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    setIsFlowLogOpen(true)
  }

  useEffect(() => {
    // Check if text is overflowing
    const checkOverflow = () => {
      if (textRef.current && containerRef.current) {
        const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth
        setShouldAnimate(isOverflowing)
      }
    }

    checkOverflow()
    window.addEventListener('resize', checkOverflow)

    // Add the marquee animation styles with initial delay
    const style = document.createElement('style')
    style.textContent = `
      @keyframes marquee {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .animate-marquee {
        animation: marquee 10s linear infinite;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
      window.removeEventListener('resize', checkOverflow)
    }
  }, [])

  return (
    <>
      <div className="flex items-center justify-center cursor-pointer group w-full" onClick={handleClick}>
        <div
          className={`relative flex items-center justify-between ${isDarkMode ? 'bg-gray-800' : 'bg-white'} px-4 py-3 rounded-full shadow-2xl hover:shadow-xl transition-all 
          border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} 
          ring-2 ${isDarkMode ? 'ring-gray-700' : 'ring-gray-200'} 
          hover:${isDarkMode ? 'ring-gray-600' : 'ring-gray-300'} 
          hover:scale-105 
          active:scale-95 
          transform 
          duration-200 
          ease-in-out
          animate-breathing
          w-[220px]`}
        >
          <div className="flex items-center">
            <div className="mr-2">
              <FlowingStreams size="h-8 w-8" />
            </div>
            <div className="flex flex-col -space-y-2">
              <span className={`font-bold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Enter Flow</span>
              <div ref={containerRef} className="w-[120px] overflow-hidden">
                <div
                  ref={textRef}
                  className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} whitespace-nowrap ${shouldAnimate ? 'animate-marquee' : ''}`}
                  style={{ display: 'inline-block' }}
                >
                  {shouldAnimate ? (
                    <>
                      <span style={{ marginRight: '40px' }}>{subtitle}</span>
                      <span style={{ marginRight: '40px' }}>{subtitle}</span>
                    </>
                  ) : (
                    subtitle
                  )}
                </div>
              </div>
            </div>
          </div>
          {unreadCount > 0 && (
            <div
              className="flex items-center justify-center rounded-full"
              style={{
                backgroundColor: '#FF4A8E',
                color: '#FFFFFF',
                width: '24px',
                height: '24px',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              {unreadCount}
            </div>
          )}
        </div>
      </div>

      <FlowLogModal isOpen={isFlowLogOpen} onClose={() => setIsFlowLogOpen(false)} />
    </>
  )
}
*/

const FloatingActionButton = () => {
  const { isModalOpen } = useChatStore()
  const { config, isLoading } = useContext(RemoteConfigContext)

  // Do not show button while loading remote config
  if (isLoading) return null

  const shouldShow = config?.askAnything ?? true // default to true if flag missing

  if (isModalOpen || !shouldShow) return null

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center justify-center gap-4">
      <AskAnythingButton />
      {/* <EnterFlowButton /> */}
    </div>
  )
}

export default FloatingActionButton
